import React, { useState } from 'react';
import { Table as AntTable, Typography, Button, Space } from 'antd';
import { genNumberTable } from '../../../../function/genNumberTable';
import DetailsModal from './DetailsModal';
import { SearchOutlined } from '@ant-design/icons';
const { Title, Text } = Typography;

const headerStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "#4a4a4a",
  textAlign: 'center',
};

const Table = ({ data = [], loading = false, handleSearch, pagination, onPaginationChange }) => {
  const [modalReportVisible, setModalReportVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const handleViewDetails = (record) => {
    setSelectedRecord(record);
    setModalReportVisible(true);
  };

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'number',
      key: 'number',
      align: 'center',
      // width: 120,
      onHeaderCell: () => ({ style: headerStyle }),
      //render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'สร้างโดย',
      dataIndex: 'create_by',
      key: 'create_by',
      align: 'center',
      // width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      //render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'สร้างตอน',
      dataIndex: 'create_date',
      key: 'create_date',
      align: 'center',
      // width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
    },
    {
      title: 'หัวข้อ',
      dataIndex: 'caseName',
      key: 'caseName',
      align: 'center',
      // width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      // render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || 0}</span>,
    },
    {
      title: 'รายละเอียด',
      key: 'details',
      align: 'center',
      width: 120,
      fixed: 'right',
      onHeaderCell: () => ({ style: headerStyle }),
      render: (_, record) => (
        <Button
          type="text"
          icon={<SearchOutlined style={{ color: '#1890ff', fontSize: '18px' }} />}
          onClick={() => handleViewDetails(record)}
          style={{ borderRadius: 6 }}
        />
      ),
    },
  ];

  return (
    <div style={{ padding: '20px', background: '#fff' }}>
      <div className='overflow-x-auto'>
        <AntTable
          loading={loading}
          dataSource={genNumberTable(data)}
          columns={columns}
          scroll={{ x: 'max-content' }}
          bordered
          pagination={{
            current: pagination?.current || 1,
            pageSize: pagination?.pageSize || 10,
            total: pagination?.total || 0,
            showSizeChanger: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} จาก ${total} รายการ`,
            pageSizeOptions: ['10', '20', '50', '100'],
            onChange: (page, pageSize) => onPaginationChange?.(page, pageSize),
          }}
          rowKey={'id'}
        />

      </div>

      <DetailsModal
        visible={modalReportVisible}
        onClose={() => {
          setModalReportVisible(false);
          setSelectedRecord(null);
          //handleSearch()
        }}
        record={selectedRecord}
        //refetch={handleSearch}
      />
      <style>{`
        .table-row-light {
          background-color: #f5f5f5;
        }
        .ant-table-tbody > tr:hover > td {
          background-color: #e8f4f8 !important;
        }
      `}</style>
    </div>
  );
};

export default Table;

